import { useAsyncAction } from "@/hooks/useAsyncAction";
import { api, type Proveedor } from "@/lib/api";

/** Alta rápida de un proveedor (sólo el nombre) desde el formulario de gasto: lo crea en la agenda, recarga la lista
 * y lo deja elegido. El resto de los datos se completa después en Proveedores. */
export function useCrearProveedor(fid: number, recargar: () => void, elegir: (proveedorId: string) => void) {
  const accion = useAsyncAction((nombre: string) => api.post<Proveedor>(`/api/fideicomisos/${fid}/proveedores`, { nombre }));
  const crear = async (nombre: string) => {
    const nuevo = await accion.run(nombre);
    if (!nuevo) return;
    recargar();
    elegir(String(nuevo.id));
  };
  return { crearProveedor: (nombre: string) => void crear(nombre), errorCrearProveedor: accion.error, limpiarErrorProveedor: accion.limpiarError };
}
